/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCommentingUnitCode, fetchCommentingConfig } from '../../../../state/thunks/commenting';
// utils
// material
import { Page, Content, CopySnippetField, InlineMessage, Loader, InContentMessage } from '@insticator/insticator-ui';
import PageHeader from "../../../../material/structure/pageheader/pageheader";
import PageContent from "../../../../material/structure/pagecontent/pagecontent";
import SiteFilter from '../../../../material/sitefilter/sitefilter';
import CardWrapper from '../../../../material/cardwrapper/cardwrapper';
// content
// styles
import injectSheet from "react-jss";
import styles from './code_styles.js';

/* ========== ~~~~~~~~~~ COMMENTING: GET CODE PAGE ~~~~~~~~~~ ========== */
const CommentingCodePage = injectSheet(styles)((props) => {

  const dispatch = useDispatch();
  const { accountUUID, siteUUID } = useSelector((state) => state.session)
  const { sites } = useSelector(state => state.account) 
  const commentingUnitCode = useSelector(({commenting}) => commenting.commentingUnitCode);
  const isPageIDEnabled = useSelector(({commenting}) => commenting.commentingConfig.data?.general?.isPageIDEnabled);
  const [isLoading,setIsLoading] = useState(true)

  useEffect(() => {
    if(accountUUID && siteUUID) loadCommentingConfig()
  }, [accountUUID, siteUUID]) 

  const loadCommentingConfig = useCallback(async()=>{
    const response = await dispatch(fetchCommentingConfig({accountUUID, siteUUID, siteURL: sites[siteUUID] }))
    const unitCode = await dispatch(fetchCommentingUnitCode({siteUUID}))
    setIsLoading(false)
  }, [siteUUID, accountUUID])

  return (
    <Page name={'commentingcodepage'} klass={`${props.classes.commentingcodepage}`}>
      <SiteFilter />
      <Content>
         <InContentMessage />
        <PageHeader title={'Commenting'} subtitle={'Get Code'}  />
        <PageContent>
          <CardWrapper>
            { ['initial', 'pending'].includes(commentingUnitCode.status) || isLoading ? 
            <div className={'loaderwrapper'}><Loader /></div>
            :
            <div className={`code ${props.classes.code}`}>
                <CopySnippetField
                  title={'Header Code'}
                  description={<div>Place the following code right after the <strong>{`<head>`}</strong> tag in your HTML source code.</div>}
                  codeSnippet={!commentingUnitCode ? '' : commentingUnitCode.headerCode}
                />
                <div className={`codemessage`}>
                    <InlineMessage 
                      key={'meow'}
                      display={true}
                      name={'headercode'}
                      variant={'neutral'}
                      icon={'exclamation-triangle'}
                      title={null}
                      message={<span><strong>Insticator Header Code</strong> is the same for all ‘hard-coded’ insticator units – <strong>only add it to your site once.</strong></span>}
                      close={false}
                      handleClose={null} 
                    />
                </div>
                <CopySnippetField
                  title={'Commenting Unit Code'}
                  description={
                    <div>Place the Commenting Unit code inside of the <strong>{`<body>`}</strong> tag in your HTML source code where you want the Commenting Unit to appear in your site.
                    </div>
                  }
                  codeSnippet={!commentingUnitCode ? '' : commentingUnitCode.bodyCode}
                />
                {
                  isPageIDEnabled ? 
                  <div className={`codemessage`}>
                    <InlineMessage 
                      key={'meow'}
                      display={true}
                      name={'headercode'}
                      variant={'neutral'}
                      icon={'exclamation-triangle'}
                      title={null}
                      message={<span>Make sure you replace <strong>{`{extPageId}`}</strong> with the proper External Page ID value for the specific page.</span>}
                      close={false}
                      handleClose={null} 
                    />
                  </div> : null
                }
            </div>
            }
          </CardWrapper>
        </PageContent>
      </Content>
    </Page>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default CommentingCodePage